// extracted by mini-css-extract-plugin
export default {"container":"TextCoordinates_container__dYJc+","coordinates":"TextCoordinates_coordinates__cbhsI","textLocation__legendStyle":"TextCoordinates_textLocation__legendStyle__swhYH"};